module.exports = __webpack_public_path__ + "static/media/Roboticon01@3x.1eaf3344.png";